import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components';
import { useRootStore } from '../../../providers/root-store-provider';
import { IconWarning } from '../icons/warning';
import { IconError } from '../icons/error';
import { IconInfo } from '../icons/info';

export const CriticalNotification: React.FC = observer(() => {
    const rootStore = useRootStore();
    const theme = useTheme();
    const { criticalNotificationStore } = rootStore;

    const lastNotification = criticalNotificationStore.lastCriticalNotification;

    if (!lastNotification) return null;

    let iconComponent = <IconInfo />;
    let variant: 'negative' | 'warning' | 'blue' = 'blue';

    if (lastNotification.isCritical) {
        iconComponent = <IconError />;
        variant = 'negative';
    } else if (lastNotification.isWarning) {
        iconComponent = <IconWarning />;
        variant = 'warning';
    }

    return (
        <div
            className="sticky top-0 z-[902] flex min-h-[var(--critical-notification-height)] items-center justify-center p-vsmall text-small leading-small font-bold lg:px-vsmall lg:py-0"
            style={
                {
                    '--critical-notification-height': theme.base.barHeight,
                    background: theme.palette.color[variant].lighten,
                    color: theme.palette.color.white.main,
                    boxShadow: `inset 0 -0.1rem 0.4rem ${theme.palette.color[variant].main}`,
                } as React.CSSProperties
            }
        >
            <div className="flex items-center gap-xsmall text-center">
                <span className="relative inline-flex text-inherit [&_i]:h-[1.4rem] [&_i]:w-[1.4rem]">
                    {iconComponent}
                </span>
                {lastNotification.text}
            </div>
        </div>
    );
});
